'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIntrospectionEnabled = exports.isIntrospectionEnabled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usesIntrospection = _propTypes2.default.any.__INTROSPECTION__;

/**
 * @return {boolean}
 */
var isIntrospectionEnabled = exports.isIntrospectionEnabled = function isIntrospectionEnabled() {
  return usesIntrospection;
};

/**
 * Override for testing logic dependent on isIntrospectionEnabled()
 * @param {boolean} newUsesIntrospection
 */
var setIntrospectionEnabled = exports.setIntrospectionEnabled = function setIntrospectionEnabled(newUsesIntrospection) {
  usesIntrospection = newUsesIntrospection;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/utils/propTypes/internal/introspection.js
// module id = 174
// module chunks = 177